
const backend = "https://api.pipehub.net";

export {
    backend
};